import uuid from 'react-uuid';

export const creatUUId = () => uuid();
